import {
  SearchParams,
  encodeSearchParams,
} from '@elemental/pagination-helpers';
import { GridSortItem } from '@mui/x-data-grid-pro';

import { DataRecord } from '../redux/data';
import { DataLoadProps } from '../types/pagination';

/**
 * converts data load options to encoded querystring and replace it in URL
 */
const dataLoadToRoute = ({ paginationModel, sortModel }: DataLoadProps) => {
  const searchParams: SearchParams<DataRecord> = {
    page: paginationModel.page,
    per_page: paginationModel.pageSize,
    sort_by: sortModel.map((entry: GridSortItem) => ({
      column: entry.field as keyof DataRecord,
      sort_ascending: entry.sort === 'asc',
    })),
  };

  const queryParams = new URLSearchParams(globalThis.location.search);

  queryParams.delete('dataLoad');

  const encodedParams = encodeSearchParams(searchParams);
  const dataLoadParams = new URLSearchParams(
    encodedParams as Record<string, string>,
  );

  const newUrl = `${
    globalThis.location.pathname
  }?${queryParams.toString()}&dataLoad=${encodeURIComponent(dataLoadParams.toString())}`;

  globalThis.history.replaceState({}, '', newUrl);
};

export default dataLoadToRoute;
